import { useQuery } from '@apollo/client';
import Hubspot from '@clearkit/icons/glyphs/Hubspot';
import Marketo from '@clearkit/icons/glyphs/Marketo';
import Pardot from '@clearkit/icons/glyphs/Salesforce';

import IntegrationPickerCard from '~/components/IntegrationPickerCard';
import {
  IntegrationPickerLayout,
  IntegrationPickerRow,
} from '~/components/layouts/IntegrationPickerLayout';
import SidebarDrawer from '~/components/SidebarDrawer';
import UpgradeAccountForm from '~/components/UpgradeAccountForm';
import Tile from '~/images/Tiles/Forms.svg';

import query from './query.graphql';

const integrations = [
  {
    Icon: Hubspot,
    bgClass: 'bg-hubspot',
    title: 'Clearbit for Hubspot',
    text: 'Improve HubSpot form conversion rates',
    tag: 'MAP',
    url: '/forms/hubspot',
  },
  {
    Icon: Marketo,
    bgClass: 'bg-marketo',
    title: 'Marketo',
    text: 'Improve Marketo form conversion rates',
    tag: 'MAP',
    url: '/forms/marketo',
  },
  {
    Icon: Pardot,
    bgClass: 'bg-salesforce',
    title: 'Pardot',
    text: 'Improve Pardot form conversion rates',
    tag: 'MAP',
    url: '/forms/pardot',
  },
];

const FormsLandingPage = () => {
  const { data: { account } = {}, loading } = useQuery(query);
  const [showUpgradeForm, setShowUpgradeForm] = useState(false);

  const accessibleIntegrations = [];
  const unaccessibleIntegrations = [];

  integrations.forEach((integration) => {
    if (
      !integration.plan ||
      account?.plans.some((plan) => plan === integration.plan)
    ) {
      accessibleIntegrations.push(integration);
    } else {
      unaccessibleIntegrations.push(integration);
    }
  });

  return (
    <IntegrationPickerLayout
      title="Forms"
      subtitle="Improve conversions with form autofill and shortening"
      loading={loading}
      tile={<Tile />}
      shadow>
      <div className="flex flex-col flex-grow">
        {accessibleIntegrations.length > 0 && (
          <IntegrationPickerRow
            title="Form integrations"
            subtitle="Select your desired Form integration to get started.">
            {accessibleIntegrations.map((integration) => {
              return (
                <IntegrationPickerCard
                  key={integration.title}
                  {...integration}
                  hasAccess
                  hasPermission
                />
              );
            })}
          </IntegrationPickerRow>
        )}
        {unaccessibleIntegrations.length > 0 && (
          <IntegrationPickerRow
            title="Available integrations"
            subtitle="Select your desired Form integration to get started."
            secondary>
            {unaccessibleIntegrations.map((integration) => {
              return (
                <IntegrationPickerCard
                  key={integration.title}
                  {...integration}
                  hasAccess={false}
                  setShowUpgradeForm={setShowUpgradeForm}
                />
              );
            })}
          </IntegrationPickerRow>
        )}
      </div>

      <SidebarDrawer
        open={showUpgradeForm}
        onClose={() => {
          setShowUpgradeForm(false);
        }}>
        <UpgradeAccountForm
          onClose={() => {
            setShowUpgradeForm(false);
          }}
          product="dataEnrichment"
        />
      </SidebarDrawer>
    </IntegrationPickerLayout>
  );
};

export default FormsLandingPage;
